// extracted by mini-css-extract-plugin
export default {"zoomControls":"sca-z","zoomControlButton":"tca-z","zoomBanner":"uca-z","bannerButton":"vca-z","imageButton":"wca-z","zoom":"xca-z","zoomContent":"yca-z"};